import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

// Raising what the campaign is authorised to spend.
//
// Deliberately its own action rather than something that happens while adding stock, so the amount
// the client signed off can only move when somebody means to move it. The reason is required because
// this row is the only record of why the ceiling changed.

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

export default function LcvIncreaseBudgetDialog(props) {
     const { authorisedGbp, isBusy, onCancel, onConfirm } = props;

     const [amount, setAmount] = useState("");
     const [reason, setReason] = useState("");

     const amountValue = Number(amount);
     const isAmountValid = amount !== "" && !Number.isNaN(amountValue) && amountValue !== 0;
     const isReasonValid = reason.trim().length >= 3;

     return (
          <Dialog open onClose={onCancel} fullWidth maxWidth="sm">
               <DialogTitle>Increase the budget</DialogTitle>

               <DialogContent>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                         The campaign is authorised to spend {money(authorisedGbp)}.
                         {isAmountValid && ` This takes it to ${money(authorisedGbp + amountValue)}.`}
                    </Typography>

                    <TextField
                         label="Amount to add"
                         type="number"
                         value={amount}
                         onChange={(event) => setAmount(event.target.value)}
                         error={amount !== "" && !isAmountValid}
                         helperText={
                              amount !== "" && !isAmountValid
                                   ? "Enter an amount other than zero. A correction is a negative amount."
                                   : " "
                         }
                         fullWidth
                         autoFocus
                         sx={{ mb: 2 }}
                    />

                    <TextField
                         label="Reason"
                         value={reason}
                         onChange={(event) => setReason(event.target.value)}
                         error={reason !== "" && !isReasonValid}
                         helperText={
                              reason !== "" && !isReasonValid ? "Give a reason of at least 3 characters." : " "
                         }
                         fullWidth
                         multiline
                         minRows={2}
                    />
               </DialogContent>

               <DialogActions>
                    <Button type="button" onClick={onCancel} disabled={isBusy}>
                         Cancel
                    </Button>
                    <Button
                         type="button"
                         variant="contained"
                         disabled={!isAmountValid || !isReasonValid || isBusy}
                         onClick={() => onConfirm({ amountGbp: amountValue, reason: reason.trim() })}
                    >
                         Increase budget
                    </Button>
               </DialogActions>
          </Dialog>
     );
}
